import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from '../../objects/profile';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(private $db:DatabaseGwService) { }

  getProfilesRelatedApp(appId:string):Observable<any>{
    return this.$db.query({"app_id": appId}, "/app-profiles");
  }

  getUsersRelatedApp(appId:string):Observable<any>{
    return this.$db.query({"app_id": appId}, "/app-users");
  }
}
